module.exports = __webpack_public_path__ + "assets/img/w1.b1e44753.png";